"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _styledComponentsModifiers = require("styled-components-modifiers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const modifierConfig = {
  // Types
  plain: ({
    theme
  }) => "\n    border: none;\n    border-radius: 0;\n    font-family: ".concat(theme.fonts.primary, ";\n    font-weight: 600;\n    font-size: 1rem;\n    padding: 0;\n\n    &:hover {\n      background-color: transparent;\n      color: ").concat(theme.palette.primary[0], ";\n    }\n  "),
  primary: ({
    theme
  }) => "\n    color: white;\n    background-color: ".concat(theme.palette.primary[0], ";\n\n    &:hover {\n      background-color: white;\n      color: ").concat(theme.palette.primary[0], ";\n    }\n  "),
  danger: ({
    theme
  }) => "\n    border-color: ".concat(theme.palette.primary[1], ";\n    color: ").concat(theme.palette.primary[1], ";\n\n    &:hover {\n      background-color: ").concat(theme.palette.primary[1], ";\n      color: white;\n    }\n  "),
  success: ({
    theme
  }) => "\n    color: white;\n    border-color: ".concat(theme.palette.primary[2], ";\n    background-color: ").concat(theme.palette.primary[2], ";\n\n    &:hover {\n      background-color: white;\n      color: ").concat(theme.palette.primary[2], ";\n    }\n  "),
  // Sizes
  'x-small': () => "\n    font-size: ".concat((0, _polished.rem)('12px'), ";\n    padding: 6px 12px;\n    font-weight: 600;\n  "),
  small: () => "\n    font-size: ".concat((0, _polished.rem)('14px'), ";\n    padding: 6px 14px;\n    font-weight: 600;\n  "),
  large: () => "\n    font-size: ".concat((0, _polished.rem)('22px'), ";\n    padding: 10px 28px;\n  ")
};

const Button = _styledComponents.default.button.attrs({
  type: 'button'
}).withConfig({
  displayName: "Button"
})(["border:1px solid ", ";border-radius:100px;font-family:", ";font-weight:700;font-size:", ";color:", ";padding:9px 24px;cursor:pointer;transition:all 0.15s;background-color:white;&:hover{background-color:", ";color:white;}", ";"], props => props.theme.palette.primary[0], props => props.theme.fonts.primary, (0, _polished.rem)('18px'), props => props.theme.palette.primary[0], props => props.theme.palette.primary[0], (0, _styledComponentsModifiers.applyStyleModifiers)(modifierConfig));

Button.propTypes = {
  modifiers: (0, _styledComponentsModifiers.styleModifierPropTypes)(modifierConfig)
};
var _default = Button;
exports.default = _default;